import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Header from "../../stories/components/Header.js";
import LogoTableRow from "../../stories/components/LogoTableRow";
import LogoTableHead from "../../stories/components/LogoTableHead";

import {
  LogoTromsOgFinnmarkPrimaerBokmaalNegativPdf,
  LogoTromsOgFinnmarkPrimaerBokmaalNegativPng,
  LogoTromsOgFinnmarkPrimaerBokmaalNegativSvg,
  LogoTromsOgFinnmarkPrimaerBokmaalPositivPdf,
  LogoTromsOgFinnmarkPrimaerBokmaalPositivPng,
  LogoTromsOgFinnmarkPrimaerBokmaalPositivSvg,
  LogoTromsOgFinnmarkPrimaerBokmaalEngelskNegativPdf,
  LogoTromsOgFinnmarkPrimaerBokmaalEngelskNegativPng,
  LogoTromsOgFinnmarkPrimaerBokmaalEngelskNegativSvg,
  LogoTromsOgFinnmarkPrimaerBokmaalEngelskPositivPdf,
  LogoTromsOgFinnmarkPrimaerBokmaalEngelskPositivPng,
  LogoTromsOgFinnmarkPrimaerBokmaalEngelskPositivSvg,
  LogoTromsOgFinnmarkPrimaerNynorskNegativPdf,
  LogoTromsOgFinnmarkPrimaerNynorskNegativPng,
  LogoTromsOgFinnmarkPrimaerNynorskNegativSvg,
  LogoTromsOgFinnmarkPrimaerNynorskPositivPdf,
  LogoTromsOgFinnmarkPrimaerNynorskPositivPng,
  LogoTromsOgFinnmarkPrimaerNynorskPositivSvg,
  LogoTromsOgFinnmarkPrimaerNynorskEngelskNegativPdf,
  LogoTromsOgFinnmarkPrimaerNynorskEngelskNegativPng,
  LogoTromsOgFinnmarkPrimaerNynorskEngelskNegativSvg,
  LogoTromsOgFinnmarkPrimaerNynorskEngelskPositivPdf,
  LogoTromsOgFinnmarkPrimaerNynorskEngelskPositivPng,
  LogoTromsOgFinnmarkPrimaerNynorskEngelskPositivSvg,
  LogoTromsOgFinnmarkSekundaerBokmaalNegativPdf,
  LogoTromsOgFinnmarkSekundaerBokmaalNegativPng,
  LogoTromsOgFinnmarkSekundaerBokmaalNegativSvg,
  LogoTromsOgFinnmarkSekundaerBokmaalPositivPdf,
  LogoTromsOgFinnmarkSekundaerBokmaalPositivPng,
  LogoTromsOgFinnmarkSekundaerBokmaalPositivSvg,
  LogoTromsOgFinnmarkSekundaerBokmaalEngelskNegativPdf,
  LogoTromsOgFinnmarkSekundaerBokmaalEngelskNegativPng,
  LogoTromsOgFinnmarkSekundaerBokmaalEngelskNegativSvg,
  LogoTromsOgFinnmarkSekundaerBokmaalEngelskPositivPdf,
  LogoTromsOgFinnmarkSekundaerBokmaalEngelskPositivPng,
  LogoTromsOgFinnmarkSekundaerBokmaalEngelskPositivSvg,
  LogoTromsOgFinnmarkSekundaerNynorskNegativPdf,
  LogoTromsOgFinnmarkSekundaerNynorskNegativPng,
  LogoTromsOgFinnmarkSekundaerNynorskNegativSvg,
  LogoTromsOgFinnmarkSekundaerNynorskPositivPdf,
  LogoTromsOgFinnmarkSekundaerNynorskPositivPng,
  LogoTromsOgFinnmarkSekundaerNynorskPositivSvg,
  LogoTromsOgFinnmarkSekundaerNynorskEngelskNegativPdf,
  LogoTromsOgFinnmarkSekundaerNynorskEngelskNegativPng,
  LogoTromsOgFinnmarkSekundaerNynorskEngelskNegativSvg,
  LogoTromsOgFinnmarkSekundaerNynorskEngelskPositivPdf,
  LogoTromsOgFinnmarkSekundaerNynorskEngelskPositivPng,
  LogoTromsOgFinnmarkSekundaerNynorskEngelskPositivSvg,
  LogoTromsOgFinnmarkSentrertBokmaalNegativPdf,
  LogoTromsOgFinnmarkSentrertBokmaalNegativPng,
  LogoTromsOgFinnmarkSentrertBokmaalNegativSvg,
  LogoTromsOgFinnmarkSentrertBokmaalPositivPdf,
  LogoTromsOgFinnmarkSentrertBokmaalPositivPng,
  LogoTromsOgFinnmarkSentrertBokmaalPositivSvg,
  LogoTromsOgFinnmarkSentrertBokmaalEngelskNegativPdf,
  LogoTromsOgFinnmarkSentrertBokmaalEngelskNegativPng,
  LogoTromsOgFinnmarkSentrertBokmaalEngelskNegativSvg,
  LogoTromsOgFinnmarkSentrertBokmaalEngelskPositivPdf,
  LogoTromsOgFinnmarkSentrertBokmaalEngelskPositivPng,
  LogoTromsOgFinnmarkSentrertBokmaalEngelskPositivSvg,
  LogoTromsOgFinnmarkSentrertNynorskNegativPdf,
  LogoTromsOgFinnmarkSentrertNynorskNegativPng,
  LogoTromsOgFinnmarkSentrertNynorskNegativSvg,
  LogoTromsOgFinnmarkSentrertNynorskPositivPdf,
  LogoTromsOgFinnmarkSentrertNynorskPositivPng,
  LogoTromsOgFinnmarkSentrertNynorskPositivSvg,
  LogoTromsOgFinnmarkSentrertNynorskEngelskNegativPdf,
  LogoTromsOgFinnmarkSentrertNynorskEngelskNegativPng,
  LogoTromsOgFinnmarkSentrertNynorskEngelskNegativSvg,
  LogoTromsOgFinnmarkSentrertNynorskEngelskPositivPdf,
  LogoTromsOgFinnmarkSentrertNynorskEngelskPositivPng,
  LogoTromsOgFinnmarkSentrertNynorskEngelskPositivSvg,
} from "../../assets/logo/Troms-og-Finnmark/exportTromsOgFinnmark.js";

export default function TromsOgFinnmarkPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Logofiler for Statsforvalteren i Troms og Finnmark"
          lead="Alle logoer for Troms og Finnmark i ulike variasjoner og filformater"
          breadcrumbText="Tilbake til logo"
          breadcrumbUrl="/logo"
        />
        <main>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <p>Tekst om logovarianter og filformater...</p>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Primærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoTromsOgFinnmarkPrimaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Troms og Finnmark, bokmål"
                    text="Bokmål"
                    blackSvg={LogoTromsOgFinnmarkPrimaerBokmaalPositivSvg}
                    blackPng={LogoTromsOgFinnmarkPrimaerBokmaalPositivPng}
                    blackPdf={LogoTromsOgFinnmarkPrimaerBokmaalPositivPdf}
                    whiteSvg={LogoTromsOgFinnmarkPrimaerBokmaalNegativSvg}
                    whitePng={LogoTromsOgFinnmarkPrimaerBokmaalNegativPng}
                    whitePdf={LogoTromsOgFinnmarkPrimaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTromsOgFinnmarkPrimaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Troms og Finnmark, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoTromsOgFinnmarkPrimaerBokmaalEngelskPositivSvg}
                    blackPng={LogoTromsOgFinnmarkPrimaerBokmaalEngelskPositivPng}
                    blackPdf={LogoTromsOgFinnmarkPrimaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoTromsOgFinnmarkPrimaerBokmaalEngelskNegativSvg}
                    whitePng={LogoTromsOgFinnmarkPrimaerBokmaalEngelskNegativPng}
                    whitePdf={LogoTromsOgFinnmarkPrimaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTromsOgFinnmarkPrimaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Troms og Finnmark, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoTromsOgFinnmarkPrimaerNynorskPositivSvg}
                    blackPng={LogoTromsOgFinnmarkPrimaerNynorskPositivPng}
                    blackPdf={LogoTromsOgFinnmarkPrimaerNynorskPositivPdf}
                    whiteSvg={LogoTromsOgFinnmarkPrimaerNynorskNegativSvg}
                    whitePng={LogoTromsOgFinnmarkPrimaerNynorskNegativPng}
                    whitePdf={LogoTromsOgFinnmarkPrimaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTromsOgFinnmarkPrimaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Troms og Finnmark, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoTromsOgFinnmarkPrimaerNynorskEngelskPositivSvg}
                    blackPng={LogoTromsOgFinnmarkPrimaerNynorskEngelskPositivPng}
                    blackPdf={LogoTromsOgFinnmarkPrimaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoTromsOgFinnmarkPrimaerNynorskEngelskNegativSvg}
                    whitePng={LogoTromsOgFinnmarkPrimaerNynorskEngelskNegativPng}
                    whitePdf={LogoTromsOgFinnmarkPrimaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sekundærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoTromsOgFinnmarkSekundaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Troms og Finnmark, bokmål"
                    text="Bokmål"
                    blackSvg={LogoTromsOgFinnmarkSekundaerBokmaalPositivSvg}
                    blackPng={LogoTromsOgFinnmarkSekundaerBokmaalPositivPng}
                    blackPdf={LogoTromsOgFinnmarkSekundaerBokmaalPositivPdf}
                    whiteSvg={LogoTromsOgFinnmarkSekundaerBokmaalNegativSvg}
                    whitePng={LogoTromsOgFinnmarkSekundaerBokmaalNegativPng}
                    whitePdf={LogoTromsOgFinnmarkSekundaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTromsOgFinnmarkSekundaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Troms og Finnmark, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoTromsOgFinnmarkSekundaerBokmaalEngelskPositivSvg}
                    blackPng={LogoTromsOgFinnmarkSekundaerBokmaalEngelskPositivPng}
                    blackPdf={LogoTromsOgFinnmarkSekundaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoTromsOgFinnmarkSekundaerBokmaalEngelskNegativSvg}
                    whitePng={LogoTromsOgFinnmarkSekundaerBokmaalEngelskNegativPng}
                    whitePdf={LogoTromsOgFinnmarkSekundaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTromsOgFinnmarkSekundaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Troms og Finnmark, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoTromsOgFinnmarkSekundaerNynorskPositivSvg}
                    blackPng={LogoTromsOgFinnmarkSekundaerNynorskPositivPng}
                    blackPdf={LogoTromsOgFinnmarkSekundaerNynorskPositivPdf}
                    whiteSvg={LogoTromsOgFinnmarkSekundaerNynorskNegativSvg}
                    whitePng={LogoTromsOgFinnmarkSekundaerNynorskNegativPng}
                    whitePdf={LogoTromsOgFinnmarkSekundaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTromsOgFinnmarkSekundaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Troms og Finnmark, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoTromsOgFinnmarkSekundaerNynorskEngelskPositivSvg}
                    blackPng={LogoTromsOgFinnmarkSekundaerNynorskEngelskPositivPng}
                    blackPdf={LogoTromsOgFinnmarkSekundaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoTromsOgFinnmarkSekundaerNynorskEngelskNegativSvg}
                    whitePng={LogoTromsOgFinnmarkSekundaerNynorskEngelskNegativPng}
                    whitePdf={LogoTromsOgFinnmarkSekundaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sentert logo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoTromsOgFinnmarkSentrertBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Troms og Finnmark, bokmål"
                    text="Bokmål"
                    blackSvg={LogoTromsOgFinnmarkSentrertBokmaalPositivSvg}
                    blackPng={LogoTromsOgFinnmarkSentrertBokmaalPositivPng}
                    blackPdf={LogoTromsOgFinnmarkSentrertBokmaalPositivPdf}
                    whiteSvg={LogoTromsOgFinnmarkSentrertBokmaalNegativSvg}
                    whitePng={LogoTromsOgFinnmarkSentrertBokmaalNegativPng}
                    whitePdf={LogoTromsOgFinnmarkSentrertBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTromsOgFinnmarkSentrertBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Troms og Finnmark, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoTromsOgFinnmarkSentrertBokmaalEngelskPositivSvg}
                    blackPng={LogoTromsOgFinnmarkSentrertBokmaalEngelskPositivPng}
                    blackPdf={LogoTromsOgFinnmarkSentrertBokmaalEngelskPositivPdf}
                    whiteSvg={LogoTromsOgFinnmarkSentrertBokmaalEngelskNegativSvg}
                    whitePng={LogoTromsOgFinnmarkSentrertBokmaalEngelskNegativPng}
                    whitePdf={LogoTromsOgFinnmarkSentrertBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTromsOgFinnmarkSentrertNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Troms og Finnmark, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoTromsOgFinnmarkSentrertNynorskPositivSvg}
                    blackPng={LogoTromsOgFinnmarkSentrertNynorskPositivPng}
                    blackPdf={LogoTromsOgFinnmarkSentrertNynorskPositivPdf}
                    whiteSvg={LogoTromsOgFinnmarkSentrertNynorskNegativSvg}
                    whitePng={LogoTromsOgFinnmarkSentrertNynorskNegativPng}
                    whitePdf={LogoTromsOgFinnmarkSentrertNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoTromsOgFinnmarkSentrertNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Troms og Finnmark, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoTromsOgFinnmarkSentrertNynorskEngelskPositivSvg}
                    blackPng={LogoTromsOgFinnmarkSentrertNynorskEngelskPositivPng}
                    blackPdf={LogoTromsOgFinnmarkSentrertNynorskEngelskPositivPdf}
                    whiteSvg={LogoTromsOgFinnmarkSentrertNynorskEngelskNegativSvg}
                    whitePng={LogoTromsOgFinnmarkSentrertNynorskEngelskNegativPng}
                    whitePdf={LogoTromsOgFinnmarkSentrertNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
